import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { TreeSelect } from 'ant-design-vue';
import { upload } from '@/services/common';
import moment from 'moment';
import fanyiPic from '@/assets/fanyi.png';
import FooterToolBar from '@/components/tool/FooterToolBar';
var SHOW_PARENT = TreeSelect.SHOW_PARENT;
import TinymceEditor from '@/components/tinymce';
import { getActivityDetail } from '@/services/marketing/activity';
export default {
  name: 'ActivityInfo',
  i18n: require('../i18n-activity'),
  components: {
    TreeSelect: TreeSelect,
    FooterToolBar: FooterToolBar,
    TinymceEditor: TinymceEditor
  },
  props: {
    activityType: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    var _this = this;
    var validateActivitytime = function validateActivitytime(rule, value, callback) {
      if (_this.activityinfoparam.timeArry.length == 0) {
        callback(new Error(_this.$t('activity.selectactivitytime')));
      } else {
        callback();
      }
    };
    return {
      isOrder: false,
      nameErr: this.$t('activity.nameprop'),
      updateLoading: false,
      loading: false,
      imageUrl: '',
      disabledareaList: [],
      fanyiPic: fanyiPic,
      oneshowFY: true,
      threehowFY: false,
      twoshowFY: false,
      SHOW_PARENT: SHOW_PARENT,
      rules: {
        timeArry: [{
          required: true,
          validator: validateActivitytime,
          trigger: 'change'
        }]
      },
      activitystarttime: '',
      activityendtime: '',
      activityinfoparam: {
        //活动类型名称
        // activityType: '',
        // activityTypeName: '',
        multilingualList: [],
        timeArry: [],
        startTime: '',
        endTime: '',
        // activityDescUrl: '',
        descList: []
      },
      activityLangList: [],
      tabKey: '0'
    };
  },
  watch: {
    'activityinfoparam.timeArry': function activityinfoparamTimeArry() {
      if (this.activityinfoparam.timeArry.length > 0) {
        this.$refs.ruleForm.clearValidate("timeArry");
      }
    }
  },
  created: function created() {
    this.getActivityInfo();
    this.$route.query.id && this.getData();
  },
  activated: function activated() {
    this.getActivityInfo();
    this.$route.query.id && this.getData();
  },
  methods: {
    tabChange: function tabChange(activeKey) {
      var self = this;
      self.tabKey = activeKey;
    },
    /* 控制不能选择当前时间之前的数据 */disabledDate: function disabledDate(current) {
      return moment(current).format('YYYY-MM-DD HH') < moment(new Date()).format('YYYY-MM-DD HH');
    },
    /* 下一步 */nextStep: function nextStep() {
      var _this2 = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var params = {
            activityType: 0,
            startTime: _this2.activityinfoparam.startTime,
            endTime: _this2.activityinfoparam.endTime,
            nameList: _this2.activityinfoparam.multilingualList,
            descList: _this2.activityinfoparam.descList
          };
          _this2.$emit('nextStep', params);
        } else {
          return false;
        }
      });
    },
    /* 获取localStorage里面的默认语言 和系统设置中存的语言list */getInitialValue: function getInitialValue() {
      var self = this;
      self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
      self.langList = JSON.parse(localStorage.getItem('langList'));
      self.activityLangList = [];
      var _iterator = _createForOfIteratorHelper(self.langList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var nameObj = {};
          //因为编辑的是否需要id
          nameObj.id = '';
          nameObj.titleName = self.$t('activity.name') + '(' + item.langName + ')';
          //多语言id
          nameObj.langId = item.langId;
          nameObj.descName = item.langName;
          //活动名称
          nameObj.name = "";
          if (item.langId == self.defaultLangObj.langId) {
            nameObj.required = true;
            self.tabKey = item.langId;
          } else {
            nameObj.required = false;
          }
          nameObj.showNameFY = false;
          self.activityLangList.push(nameObj);
        }
        //多语言名称
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      self.activityinfoparam.multilingualList = _.cloneDeep(self.activityLangList);
      self.activityinfoparam.descList = [];
      self.activityLangList.forEach(function (item1) {
        var obj = {
          langId: item1.langId,
          name: item1.descName,
          desc: ''
        };
        console.log(obj, 'obj....................');
        self.activityinfoparam.descList.push(obj);
      });
    },
    getActivityInfo: function getActivityInfo() {
      //获取系统中的多语言
      this.getInitialValue();
      // this.activityinfoparam.activityType=this.activityType
      //1:单品打折 2:单品积分翻倍 3:单品特价 4:满减活动 5:满折活动
      // if (this.activityType == 1) {
      // 	this.activityinfoparam.activityTypeName = this.$t('activity.unitdiscount')
      // } else if (this.activityType == 2) {
      // 	this.activityinfoparam.activityTypeName = this.$t('activity.doublepoints')
      // } else if (this.activityType == 3) {
      // 	this.activityinfoparam.activityTypeName = this.$t('activity.specialoffer')
      // } else if (this.activityType == 4) {
      // 	this.activityinfoparam.activityTypeName = this.$t('activity.fullreduction')
      // } else {
      // 	this.activityinfoparam.activityTypeName = this.$t('activity.fulldiscount')
      // }
    },
    onChange: function onChange(value, dateString) {
      this.activityinfoparam.startTime = value[0];
      this.activityinfoparam.endTime = value[1];
    },
    onOk: function onOk(value) {
      // this.activityinfoparam.startTime = value[0]
      // this.activityinfoparam.endTime = value[1]
    },
    showFYBtn: function showFYBtn(activityNameObj) {
      // let self = this;
      // let couponNameObjClone = self.couponinfoparam.multilingualList;
      // for (let one of couponNameObjClone) {
      // 	one.showNameFY = false;
      // }
      // self.couponinfoparam.multilingualList = couponNameObjClone;
      // couponNameObj.showNameFY = true;
    },
    imgUpload: function imgUpload(blobInfo, success, failure) {
      var formData = new FormData();
      formData.append('type', 6);
      formData.append('file', blobInfo.blob(), blobInfo.filename());
      upload(formData).then(function (res) {
        if (res.data.code == 200) {
          success(res.data.data.urlpath + res.data.data.uploadfilepath);
        }
      });
    },
    getData: function getData() {
      var _this3 = this;
      getActivityDetail(this.$route.query.id).then(function (res) {
        if (res.data.code == 200) {
          var activityData = res.data.data;
          if (activityData != null) {
            var dataList = activityData.nameList;
            var langList = _.cloneDeep(_this3.activityLangList);
            var _iterator2 = _createForOfIteratorHelper(langList),
              _step2;
            try {
              var _loop = function _loop() {
                var langObj = _step2.value;
                var findObj = _.find(dataList, function (o) {
                  return o.langId == langObj.langId;
                });
                if (findObj) {
                  langObj.id = findObj.id;
                  langObj.name = findObj.name;
                }
              };
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                _loop();
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            _this3.activityinfoparam.multilingualList = _.cloneDeep(langList);
            _this3.activityinfoparam.startTime = activityData.startTime;
            _this3.activityinfoparam.endTime = activityData.endTime;
            _this3.activityinfoparam.timeArry.push(activityData.startTime);
            _this3.activityinfoparam.timeArry.push(activityData.endTime);
            _this3.activityinfoparam.descList = [];
            langList.forEach(function (item1) {
              var obj = {
                langId: item1.langId,
                name: item1.descName,
                desc: ''
              };
              if (activityData.descList instanceof Array) {
                activityData.descList.forEach(function (item2) {
                  if (item1.langId == item2.langId) {
                    obj.desc = item2.desc;
                  }
                });
              }
              _this3.activityinfoparam.descList.push(obj);
            });
            if (activityData.activityStatus > 0) {
              _this3.timeStatus = true;
            }
            if (activityData.isOrder == 1) {
              _this3.isOrder = true;
            }
          }
        }
      });
    }
  }
};